<template>
  <div class="container">
    <doughnut-chart v-if="loaded" :chartdata="chartdata" :options="options" />
  </div>
</template>

<script>
import DoughnutChart from "./DoughnutSample.vue";

export default {
  name: "GenderDoughnut",
  components: { DoughnutChart },
  data: () => ({
    loaded: false,
    chartdata: null
  }),
  async mounted () {
    this.loaded = false
    try {
      const apiData = await fetch("https://enfeller.com/dogdata/data/gender");
      const jsonData = await apiData.json();
      this.chartdata = {
        datasets: [
          {
            data: jsonData.data,
            backgroundColor:["#FF6E5E", "#529EFF"]
          }
        ],
        labels: jsonData.labels,
        responsive: true,
        maintainAspectRatio: false,
      };
      this.options = {
        responsive: true,
        maintainAspectRatio: false
      };
      this.loaded = true;
    } catch (e) {
    }
  }
}
</script>
